import React from "react";
import { motion } from "framer-motion";

export const TimelineContent = ({
  children,
  as = "div",
  animationNum,
  customVariants,
  className,
  ...props
}) => {
  const MotionComponent = motion(as);
  return (
    <MotionComponent
      custom={animationNum}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-50px" }}
      variants={customVariants}
      className={className}
      {...props}
    >
      {children}
    </MotionComponent>
  );
};